import { motion, useTransform, cubicBezier, type MotionValue } from 'motion/react'
import type { ReactNode } from 'react'
import { BEATS } from './beats'
import { ease } from '../../../lib/motion'

type Props = {
  progress: MotionValue<number>
  children: ReactNode
}

const easeStandard = cubicBezier(...ease.standard)

/** Trello list chrome that fades in behind the landed cards. */
export default function BoardPane({ progress, children }: Props) {
  const [landStart] = BEATS.land
  const opacity = useTransform(
    progress,
    [landStart - 0.08, landStart + 0.1],
    [0, 1],
    { ease: easeStandard }
  )

  return (
    <div className="relative">
      <motion.div
        style={{ opacity }}
        aria-hidden
        className="absolute -inset-3 rounded-2xl bg-surface-inset ring-1 ring-white/[0.06]"
      />
      <div className="relative">
        <motion.p
          style={{ opacity }}
          className="mb-3 text-caption font-semibold uppercase tracking-wide text-white/40"
        >
          To Do
        </motion.p>
        <div className="space-y-2">{children}</div>
      </div>
    </div>
  )
}
